import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap, MapLocKeys } from '@cm/core/localization';

const pathStart = 'Candidate|Security|Violation Details|RSI-SSI|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.ExamSecurity,
	portal: 'SP',
};

export type SPRsiSsiViolationDetailsLocs =
	| 'SPRsiSsiViolationDetailsTitlePageSection'
	| 'SPRsiSsiViolationDetailsTitlePageSectionRsiDetails'
	| 'SPRsiSsiViolationDetailsTitlePageSectionSsiDetails'
	| 'SPRsiSsiViolationDetailsLabelRegistration'
	| 'SPRsiSsiViolationDetailsLabelName'
	| 'SPRsiSsiViolationDetailsLabelExamDate'
	| 'SPRsiSsiViolationDetailsLabelForm'
	| 'SPRsiSsiViolationDetailsLabelTestCenter'
	| 'SPRsiSsiViolationDetailsLabelRsiZScoreCount'
	| 'SPRsiSsiViolationDetailsLabelSsiZScoreCount'
	| 'SPRsiSsiViolationDetailsLabelNumberCorrect'
	| 'SPRsiSsiViolationDetailsLabelNumberIncorrect'
	| 'SPRsiSsiViolationDetailsTableColumnRegistrationNumber'
	| 'SPRsiSsiViolationDetailsTableColumnExamDate'
	| 'SPRsiSsiViolationDetailsTableColumnZScore'
	| 'SPRsiSsiViolationDetailsTableColumnMatchingExam'
	| 'SPRsiSsiViolationDetailsTableColumnProbability'
	| 'SPRsiSsiViolationDetailsTableColumnTestCenter'
	| 'SPRsiSsiViolationDetailsTableColumnCandidate'
	| 'SPRsiSsiViolationDetailsTableColumnStatus'
	| 'SPRsiSsiViolationDetailsTableStatusBanned'
	| 'SPRsiSsiViolationDetailsTableStatusWatched'
	| 'SPRsiSsiViolationDetailsTableStatusRestricted'
	| 'SPRsiSsiViolationDetailsTitlePageSectionRsiFlaggedPairs'
	| 'SPRsiSsiViolationDetailsTitlePageSectionSsiFlaggedPairs'
	| 'SPRsiSsiViolationDetailsTitlePageSectionRsiOverlapFlaggedPairs'
	| 'SPRsiSsiViolationDetailsTitlePageSectionSsiOverlapFlaggedPairs';

export const spRsiSsiViolationDetailsLocs: LocDefs<SPRsiSsiViolationDetailsLocs> = {
	SPRsiSsiViolationDetailsTitlePageSectionRsiFlaggedPairs: {
		defaultValue: 'RSI Details',
		description: 'Page Section Title - RSI Details',
		displayPath: `${pathStart}Page Section Title - RSI Details`,
		displayType: 'Title',
		...sharedProperties,
	},
	SPRsiSsiViolationDetailsTitlePageSectionSsiFlaggedPairs: {
		defaultValue: 'SSI Details',
		description: 'Page Section Title - SSI Details',
		displayPath: `${pathStart}Page Section Title - SSI Details`,
		displayType: 'Title',
		...sharedProperties,
	},
	SPRsiSsiViolationDetailsTitlePageSectionRsiOverlapFlaggedPairs: {
		defaultValue: 'RSI Overlap Details',
		description: 'Page Section Title - RSI Overlap Details',
		displayPath: `${pathStart}Page Section Title - RSI Overlap Details`,
		displayType: 'Title',
		...sharedProperties,
	},
	SPRsiSsiViolationDetailsTitlePageSectionSsiOverlapFlaggedPairs: {
		defaultValue: 'SSI Overlap Details',
		description: 'Page Section Title - SSI Overlap Details',
		displayPath: `${pathStart}Page Section Title - SSI Overlap Details`,
		displayType: 'Title',
		...sharedProperties,
	},
	SPRsiSsiViolationDetailsTitlePageSection: {
		defaultValue: 'Original Exam Details',
		description: 'Page Section Title RSI-SSI Details page',
		displayPath: `${pathStart}Page Section Title RSI-SSI`,
		displayType: 'Title',
		...sharedProperties,
	},
	SPRsiSsiViolationDetailsTitlePageSectionRsiDetails: {
		defaultValue: 'RSI Details',
		description: 'Page Section Title - RSI Details',
		displayPath: `${pathStart}Page Section Title - RSI Details`,
		displayType: 'Title',
		...sharedProperties,
	},
	SPRsiSsiViolationDetailsTitlePageSectionSsiDetails: {
		defaultValue: 'SSI Details',
		description: 'Page Section Title - SSI Details',
		displayPath: `${pathStart}Page Section Title - SSI Details`,
		displayType: 'Title',
		...sharedProperties,
	},
	SPRsiSsiViolationDetailsLabelRegistration: {
		defaultValue: 'Registration Number',
		description: 'Label for Registration Number',
		displayPath: `${pathStart}Registration Number`,
		displayType: 'Label',
		...sharedProperties,
	},
	SPRsiSsiViolationDetailsLabelName: {
		defaultValue: 'Name',
		description: 'Label for Name',
		displayPath: `${pathStart}Name`,
		displayType: 'Label',
		...sharedProperties,
	},
	SPRsiSsiViolationDetailsLabelExamDate: {
		defaultValue: 'Exam Date',
		description: 'Label for Exam Date',
		displayPath: `${pathStart}Exam Date`,
		displayType: 'Label',
		...sharedProperties,
	},
	SPRsiSsiViolationDetailsLabelForm: {
		defaultValue: 'Form',
		description: 'Label for Form',
		displayPath: `${pathStart}Form`,
		displayType: 'Label',
		...sharedProperties,
	},
	SPRsiSsiViolationDetailsLabelTestCenter: {
		defaultValue: 'Test Center',
		description: 'Label for Test Center',
		displayPath: `${pathStart}Test Center`,
		displayType: 'Label',
		...sharedProperties,
	},
	SPRsiSsiViolationDetailsLabelRsiZScoreCount: {
		defaultValue: 'RSI Z Score Count',
		description: 'Label for RSI Z Score Count',
		displayPath: `${pathStart}RSI Z Score Count`,
		displayType: 'Label',
		...sharedProperties,
	},
	SPRsiSsiViolationDetailsLabelSsiZScoreCount: {
		defaultValue: 'SSI Z Score Count',
		description: 'Label for SSI Z Score Count',
		displayPath: `${pathStart}SSI Z Score Count`,
		displayType: 'Label',
		...sharedProperties,
	},
	SPRsiSsiViolationDetailsLabelNumberCorrect: {
		defaultValue: 'Number Correct',
		description: 'Label for Number Correct',
		displayPath: `${pathStart}Number Correct`,
		displayType: 'Label',
		...sharedProperties,
	},
	SPRsiSsiViolationDetailsLabelNumberIncorrect: {
		defaultValue: 'Number Incorrect',
		description: 'Label for Number Incorrect',
		displayPath: `${pathStart}Number Incorrect`,
		displayType: 'Label',
		...sharedProperties,
	},
	SPRsiSsiViolationDetailsTableColumnRegistrationNumber: {
		defaultValue: 'Registration Number',
		description: 'Column label for Registration Number',
		displayPath: `${pathStart}Column Registration Number`,
		displayType: 'Label',
		...sharedProperties,
	},
	SPRsiSsiViolationDetailsTableColumnExamDate: {
		defaultValue: 'Exam Date',
		description: 'Column label for Exam Date',
		displayPath: `${pathStart}Column Exam Date`,
		displayType: 'Label',
		...sharedProperties,
	},
	SPRsiSsiViolationDetailsTableColumnZScore: {
		defaultValue: 'Z Score',
		description: 'Column label for Z Score',
		displayPath: `${pathStart}Column Z Score`,
		displayType: 'Label',
		...sharedProperties,
	},
	SPRsiSsiViolationDetailsTableColumnMatchingExam: {
		defaultValue: 'Matching',
		description: 'Column label for Matching Exam',
		displayPath: `${pathStart}Column Matching Exam`,
		displayType: 'Label',
		...sharedProperties,
	},
	SPRsiSsiViolationDetailsTableColumnProbability: {
		defaultValue: 'Probability',
		description: 'Column label for Probability',
		displayPath: `${pathStart}Column Probability`,
		displayType: 'Label',
		...sharedProperties,
	},
	SPRsiSsiViolationDetailsTableColumnTestCenter: {
		defaultValue: 'Test Center',
		description: 'Column label for Test Center',
		displayPath: `${pathStart}Column Test Center`,
		displayType: 'Label',
		...sharedProperties,
	},
	SPRsiSsiViolationDetailsTableColumnCandidate: {
		defaultValue: 'Candidate',
		description: 'Column label for Candidate name',
		displayPath: `${pathStart}Column Candidate`,
		displayType: 'Label',
		...sharedProperties,
	},
	SPRsiSsiViolationDetailsTableColumnStatus: {
		defaultValue: 'Status',
		description: 'Column label for Status',
		displayPath: `${pathStart}Column Status`,
		displayType: 'Label',
		...sharedProperties,
	},
	SPRsiSsiViolationDetailsTableStatusBanned: {
		defaultValue: 'Banned',
		description: 'Status value for Banned',
		displayPath: `${pathStart}Status Banned`,
		displayType: 'Content',
		...sharedProperties,
	},
	SPRsiSsiViolationDetailsTableStatusWatched: {
		defaultValue: 'Watched',
		description: 'Status value for Watched',
		displayPath: `${pathStart}Status Watched`,
		displayType: 'Content',
		...sharedProperties,
	},
	SPRsiSsiViolationDetailsTableStatusRestricted: {
		defaultValue: 'Restricted',
		description: 'Status value for Restricted',
		displayPath: `${pathStart}Status Restricted`,
		displayType: 'Content',
		...sharedProperties,
	},
};

export type SPRsiSsiViolationDetailsLocType = LocMap<SPRsiSsiViolationDetailsLocs>;
export const LOC_KEYS = MapLocKeys<SPRsiSsiViolationDetailsLocs>(spRsiSsiViolationDetailsLocs);
